import { Wysiwyg, OpenInNew } from '@mui/icons-material';
import { Grid, Hidden, Link } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  palette: {
    globalSearch: {
      link: 'rgba(0, 125, 255, 1)',
      text: 'rgba(0, 0, 0, 0.26)',
    },
  },
});

export default function ResultsList({
  woNumber,
  stockNumber,
  vin,
  index,
  vendorOrderId,
}) {
  const { t } = useTranslation('global');

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      pt={1}
      pb={1}
      key={index}
    >
      <Grid item p={1}>
        <Wysiwyg sx={{ color: theme.palette.globalSearch.text }} />
      </Grid>
      <Grid item xs={8} md={10}>
        <Grid container>
          <Grid item xs={12}>
            {woNumber}
          </Grid>
          <Grid
            item
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            {t('globalSearch.resultsList.stockNumber')}
            {stockNumber}
          </Grid>
          <Hidden mdDown>
            <Grid
              item
              sx={{ color: theme.palette.text.secondary }}
              pr={1}
              pl={1}
            >
              {t('globalSearch.resultsList.separator')}
            </Grid>
          </Hidden>
          <Grid
            item
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            {t('globalSearch.resultsList.vin')}
            {vin}
          </Grid>
        </Grid>
      </Grid>
      <Grid item flexGrow={1} textAlign={'right'}>
        <Link href={`/orders/${vendorOrderId}`} target="_blank">
          <OpenInNew sx={{ color: theme.palette.globalSearch.link }} />
        </Link>
      </Grid>
    </Grid>
  );
}
